import { useAskRedoSlidePanel } from "@redotech/redo-merchant-app-common/ask-redo/ask-redo-slide-panel-context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { TeamAnonymizationSource } from "@redotech/redo-model/team/anonymization";
import { NotificationBannerItem } from "@redotech/redo-web/arbiter-components/notification/redo-notification-banner";
import { isBeforeNow } from "@redotech/util/date";
import { useContext } from "react";
import { ActionRequiredSeverity } from "./action-required-notification";

export function getTeamDeletionMessage(
  anonymizationDate: string | Date,
  source?: TeamAnonymizationSource | null,
) {
  const deletionDate = new Date(anonymizationDate).toLocaleDateString();
  if (source === TeamAnonymizationSource.ShopifyShopRedact) {
    return `This merchant account is scheduled for deletion on ${deletionDate} because the Shopify app was uninstalled. If you believe this is in error, please let us know.`;
  }

  return `This merchant account is scheduled for deletion on ${deletionDate} due to inactivity. If you believe this is in error, please let us know.`;
}

export function useTeamDeletion(): {
  severity: ActionRequiredSeverity;
  item: NotificationBannerItem;
} | null {
  const team = useContext(TeamContext);

  const { open: openAskRedo } = useAskRedoSlidePanel();
  const openContactSupport = () => openAskRedo();

  const anonymizationDate = team?.teamAnonymization?.anonymizationDate;

  const hasAnonymizationDatePassed =
    !!anonymizationDate && isBeforeNow(new Date(anonymizationDate));

  if (!anonymizationDate || hasAnonymizationDatePassed) {
    return null;
  }

  return {
    severity: ActionRequiredSeverity.Critical,
    item: {
      id: "team-deletion",
      type: "error",
      message: getTeamDeletionMessage(
        anonymizationDate,
        team?.teamAnonymization?.source,
      ),
      actions: [
        {
          actionType: "button",
          text: "Contact support",
          hierarchy: "primary",
          onClick: openContactSupport,
        },
      ],
    },
  };
}
